import {
  createTheme,
  DEFAULT_THEME,
  mergeMantineTheme,
  Pagination,
  PasswordInput,
  TagsInput,
  MultiSelect,
  Textarea,
  TextInput,
} from "@mantine/core";

const themeOverride = createTheme({
  components: {
    Modal: {
      styles: () => ({
        title: {
          fontFamily: "Inter-Medium, sans-serif",
          fontWeight: 500,
        },
      }),
    },
    Select: {
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    },
    TextInput: TextInput.extend({
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    }),
    TagsInput: TagsInput.extend({
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    }),
    MultiSelect: MultiSelect.extend({
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    }),
    PasswordInput: PasswordInput.extend({
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    }),
    Textarea: Textarea.extend({
      styles: () => ({
        label: {
          fontSize: theme.fontSizes.sm,
          color: theme.colors.gray[6],
          fontFamily: "Inter-Medium, sans-serif",
          marginBottom: "0.25rem",
        },
      }),
    }),

    Pagination: Pagination.extend({
      styles: () => ({
        control: {
          width: "2.5rem",
          height: "2.5rem",
          border: 0,
        },
      }),
    }),
  },
  primaryColor: "blue",
  colors: {
    blue: [
      "#E7F0FA",
      "#CEE0F5",
      "#B6D1F0",
      "#9DC1EB",
      "#6CA3E0",
      "#3B84D6",
      "#0A65CC",
      "#0851A3",
      "#063D7A",
      "#042852",
      "#031E3D",
      "#021429",
      "#010A14",
    ],
    gray: [
      "#F7F7F7",
      "#E3E3E3",
      "#D5D5D5",
      "#C7C7C7",
      "#AAAAAA",
      "#8E8E8E",
      "#727272",
      "#5B5B5B",
      "#444444",
      "#2E2E2E",
      "#222222",
      "#171717",
      "#0B0B0B",
    ],
    green: [
      "#E6F2E8",
      "#CCE6D2",
      "#B3D9BB",
      "#99CCA4",
      "#66B377",
      "#339949",
      "#00801C",
      "#006616",
      "#004D11",
      "#00330B",
      "#002608",
      "#001A06",
      "#000D03",
    ],
    red: [
      "#FBE6E6",
      "#F6CCCC",
      "#F2B3B3",
      "#EE9999",
      "#E56666",
      "#DD3333",
      "#D40000",
      "#AA0000",
      "#7F0000",
      "#550000",
      "#400000",
      "#2A0000",
      "#150000",
    ],
    yellow: [
      "#FFF7E6",
      "#FFEECC",
      "#FFE6B3",
      "#FFDD99",
      "#FFCC66",
      "#FFBB33",
      "#FFAA00",
      "#CC8800",
      "#996600",
      "#664400",
      "#4D3300",
      "#332200",
      "#1A1100",
    ],
  },
  fontFamily: "Inter-Regular, sans-serif",

  headings: {
    fontFamily: "Inter-Bold, sans-serif",
  },

  fontSizes: {
    xxl: "2rem", //32px
    xl: "1.5rem", //24px
    lg: "1.125rem", //18px
    md: "1rem", //16px
    sm: "0.875rem", //14px
    xs: "0.75rem", //12px
  },
  lineHeights: {
    xxl: "2rem", //32px
    xl: "1.5rem", //24px
    lg: "1.125rem", //18px
    md: "1rem", //16px
    sm: "0.875rem", //14px
    xs: "0.75rem", //12px
  },
});

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
